import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { usePriceLists } from '@/api/accounts-receivable/price-lists/usePriceLists';
import { T, useGT } from 'gt-react';

const NONE_VALUE = '__none__';

interface PriceListSelectProps {
  value: string | null;
  onChange: (priceListId: string | null) => void;
  disabled?: boolean;
  className?: string;
  /** Label shown for the "no override" option. Customer dropdown wants
   *  "Use default", module-config wants "(no default)" — both render the
   *  null state, but the wording differs. */
  noneLabel?: string;
}

export function PriceListSelect({
  value,
  onChange,
  disabled,
  className,
  noneLabel,
}: PriceListSelectProps) {
  const gt = useGT();
  const { data, isLoading } = usePriceLists();

  return (
    <Select
      value={value ?? NONE_VALUE}
      onValueChange={(next) => onChange(next === NONE_VALUE ? null : next)}
      disabled={disabled || isLoading}
    >
      <SelectTrigger className={className} size="sm">
        <SelectValue placeholder={gt('Select a price list')} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={NONE_VALUE}>
          {noneLabel ?? <T>Use default</T>}
        </SelectItem>
        {data?.priceLists.map((pl) => (
          <SelectItem key={pl.id} value={pl.id}>
            {pl.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
